import React from 'react';
import {
  Typography,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';
import {
  MuiPickersUtilsProvider,
  DatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import svLocale from 'date-fns/locale/sv';

function MembershipDateSelector({ membershipActive, membershipExpirationTimestamp, onChange, ...props }) {

  return (
    <>
      <Typography
        variant="body2"
        component="h6"
        color="primary"
        style={{ textAlign: 'left', marginTop: 40, marginBottom: 0 }}
      >
        Medlemskap
      </Typography>

      <FormControlLabel
        control={
          <Checkbox
            checked={membershipActive}
            onChange={
              onChange
            }
            name='membership-active'
            color="primary"
          />
        }
        label="Medlem"
        style={{
          marginTop: 0,
          marginBottom: 0,
          display: 'block',
          textAlign: 'left',
        }}
      />

      <MuiPickersUtilsProvider
        utils={DateFnsUtils}
      >
        <DatePicker
          label="Medlem till"
          value={
            membershipExpirationTimestamp
          }
          onChange={date => {
            onChange({
              target: {
                name: 'membership-expiration-timestamp',
                value: date,
              }
            });
          }
          }
          locale={svLocale}
          format="d MMMM, yyyy"
          style={{
            marginBottom: 50,
            marginLeft: 0,
            display: 'block',
            textAlign: 'left',
          }}
          disabled={!membershipActive}
        />
      </MuiPickersUtilsProvider>
    </>
  );
}

export default MembershipDateSelector;